module.exports = __webpack_public_path__ + "img/DE01950.39d66ce4.png";